shadow$provide[191] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Unit:{enumerable:true, get:function() {
  return Unit;
}}});
var require$_DOT__SLASH_parent_DOT_js = require("./parent.js");
class Unit extends require$_DOT__SLASH_parent_DOT_js.Parent {
  static initClass() {
    this.traits = ["node", "unit"];
  }
  make() {
    return this._helpers.unit.make();
  }
  unmake() {
    return this._helpers.unit.unmake();
  }
  getUnit() {
    return this._helpers.unit.get();
  }
  getUnitUniforms() {
    return this._helpers.unit.uniforms();
  }
}
Unit.initClass();

};